<template>
  <div class="BookmarkCard actualiteCard">
    <div class="BookmarkCard-card actualiteCard-card">
      <div class="actualiteCard-title">
        <div
          class="BookmarkCard-tag actualiteCard-tag"
          :style="{
            '--background-color': getActualiteTypeColor(),
          }"
        >
          <span> {{ getActualiteTypeLabel() }}</span>
        </div>
        <div class="actualiteCard-publish">
          <span>{{
            $t("actualitesPage.date-publication", [formatDate(actualite.dateDebutPublication)])
          }}</span>
        </div>
      </div>
      <div class="actualiteCard-content">
        <div class="actualite-content-title">{{ actualite.titre }}</div>
        <div class="actualite-text-container">
          <div class="text-container">
            <span>{{ getActualiteTruncateContent() }}</span>
            <span v-if="isReadMore" :id="'read-more-' + actualite.id" class="read-more">{{
              $t("actualitesPage.read-more")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { ActualiteDTO } from "@/model/bean/GeneratedDTOs"
import DateUtils from "@/services/DateUtils"

const DEFAULT_ACTUALITE_TAG_COLOR = "#666"
const MAX_NUMBER_OF_CHARACTER = 100

export default defineComponent({
  name: "ActualiteCard",
  props: {
    actualite: {
      type: Object as PropType<ActualiteDTO>,
      required: true,
    },
  },

  emits: ["read-more"],
  data() {
    return {
      isReadMore: false,
    }
  },
  mounted(): void {
    this.setIsReadMore()
    this.$nextTick(() => {
      if (this.isReadMore) {
        const readMoreBtn = document.getElementById("read-more-" + this.actualite.id)
        if (readMoreBtn !== null) {
          readMoreBtn.addEventListener("click", (e) => {
            e.stopPropagation()
            this.$emit("read-more", this.actualite.id)
          })
        }
      }
    })
  },
  methods: {
    setIsReadMore(): void {
      this.isReadMore = this.actualite.contenu?.length > MAX_NUMBER_OF_CHARACTER
    },

    getActualiteTypeLabel(): string {
      if (this.actualite.type?.id) {
        return this.actualite.type.label
      } else {
        return this.$t("actualitesPage.actualite-type-undefined").toString()
      }
    },

    getActualiteTypeColor(): string {
      if (this.actualite.type?.id) {
        return this.actualite.type.color
      } else {
        return DEFAULT_ACTUALITE_TAG_COLOR
      }
    },

    getActualiteTruncateContent(): string {
      if (this.actualite.contenu && this.isReadMore) {
        return this.actualite.contenu.slice(0, MAX_NUMBER_OF_CHARACTER) + "..."
      } else {
        return this.actualite.contenu
      }
    },

    formatDate(date: Date): string {
      return DateUtils.formatDate(date)
    },
  },
})
</script>

<style lang="scss">
$color-grey: #dadada;

.BookmarkCard.actualiteCard {
  height: auto;
  margin-top: 1rem;

  &:first-of-type {
    margin-top: 0;
  }

  .BookmarkCard-card.actualiteCard-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid $color-grey;
    height: auto;
    min-height: 165px;
  }

  .actualiteCard-title {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
  }

  .BookmarkCard-tag {
    min-height: 35px;
    height: auto;

    &.actualiteCard-tag {
      display: flex;
      flex: 0 1 auto;
      align-items: center;
      width: auto;
      min-width: 200px;
      margin-right: 10px;
      text-transform: none;
      text-align: center;
      background-color: var(--background-color, "#666");

      span {
        letter-spacing: 1px;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }

  .actualiteCard-publish {
    display: flex;
    flex: 1 1 0;
    justify-content: center;
    align-items: center;
    text-align: center;

    span {
      color: $color-grey;
      font-weight: 800;
    }
  }

  .actualiteCard-content {
    margin: 20px;

    .actualite-content-title {
      font-weight: 800;
      font-size: 16px;
      padding-bottom: 0.5em;
    }
  }
}

.text-container {
  display: block;
  line-height: 1.5em;
  overflow-wrap: break-word;
  word-break: break-word;

  span {
    font-size: 14px;
  }
}

.text-container .read-more {
  padding-left: 5px;
  cursor: pointer;
  color: $color-grey;
}
</style>
